"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeChart = exports.getDownloadTranslations = exports.getAnnotations = exports.getOptions = exports.resultRange = exports.rangeColor = exports.mapSeries = void 0;
var react_1 = __importStar(require("react"));
var react_apexcharts_1 = __importDefault(require("react-apexcharts"));
var ChartStyles_1 = require("./ChartStyles");
var downloadTranslations = ["result", "laboratoryReport", "labSlipId", "sid", "name", "gender", "collected", "reportedDate"];
function adjustSeries(range, decimals) {
    if (decimals === undefined) {
        return range;
    }
    var _a = __spreadArray([], range, true), bottom = _a[0], top = _a[1];
    var ajustedTop = +(top - Math.pow(10, (-decimals))).toFixed(decimals);
    if (ajustedTop <= bottom) {
        ajustedTop = top;
    }
    return [bottom, ajustedTop];
}
function mapSeries(range, translation, lifeAgeWeightHeight) {
    var series = [];
    if (!range) {
        return series;
    }
    var top = range.scaleMax;
    if (lifeAgeWeightHeight) {
        series.push({ name: " ", color: ChartStyles_1.RangeColor.lifeAgeWeightHeight, labelColor: ChartStyles_1.InverseRangeColor.lifeAgeWeightHeight, data: [{ x: " ", y: [range.scaleMin, top] }], fixedRange: [] });
        return series;
    }
    if (range.high !== undefined) {
        series.push({ name: "high", color: ChartStyles_1.RangeColor.out, labelColor: ChartStyles_1.RangeColor.active, data: [{ x: " ", y: [range.high, top] }], fixedRange: [] });
        top = range.high;
    }
    if (range.borderlineHigh !== undefined) {
        series.push({ name: "borderlineHigh", color: ChartStyles_1.RangeColor.borderline, labelColor: ChartStyles_1.RangeColor.active, data: [{ x: " ", y: [range.borderlineHigh, top] }], fixedRange: [] });
        top = range.borderlineHigh;
    }
    if (range.normal !== undefined) {
        series.push({ name: "normal", color: ChartStyles_1.RangeColor.normal, labelColor: ChartStyles_1.RangeColor.active, data: [{ x: " ", y: [range.normal, top] }], fixedRange: [] });
        top = range.normal;
    }
    if (range.borderlineLow !== undefined) {
        series.push({ name: "borderlineLow", color: ChartStyles_1.RangeColor.borderline, labelColor: ChartStyles_1.RangeColor.active, data: [{ x: " ", y: [range.borderlineLow, top] }], fixedRange: [] });
        top = range.borderlineLow;
    }
    if (range.low !== undefined) {
        series.push({ name: "low", color: ChartStyles_1.RangeColor.out, labelColor: ChartStyles_1.RangeColor.active, data: [{ x: " ", y: [range.low, top] }], fixedRange: [] });
    }
    for (var i = 0; i < series.length; i++) {
        series[i].name = translation("results.".concat(series[i].name)).toUpperCase();
        var current = series[i].data[0].y;
        series[i].fixedRange = i === 0 ? current : adjustSeries(current, range.decimals);
    }
    return series;
}
exports.mapSeries = mapSeries;
function rangeColor(series, result, outOfRangeColor) {
    if (outOfRangeColor === void 0) { outOfRangeColor = ChartStyles_1.RangeColor.active; }
    var range = resultRange(series, result);
    return [(range === null || range === void 0 ? void 0 : range.color) || outOfRangeColor, (range === null || range === void 0 ? void 0 : range.labelColor) || ChartStyles_1.RangeColor.active];
}
exports.rangeColor = rangeColor;
function resultRange(series, result) {
    var range = series.find(function (s) { return s.data[0].y[0] === result && result === s.data[0].y[1]; });
    if (!range) {
        range = series.find(function (s) { return s.data[0].y[0] <= result && result < s.data[0].y[1]; });
    }
    if (!range && series.length) {
        var lastSeria = series[0];
        if (lastSeria.data[0].y[0] <= result && result <= lastSeria.data[0].y[1]) {
            range = lastSeria;
        }
    }
    return range;
}
exports.resultRange = resultRange;
function getOptions(series, range, lifeAgeWeightHeight, annotations) {
    return {
        chart: {
            type: "rangeBar",
            id: range === null || range === void 0 ? void 0 : range.testCode,
            toolbar: {
                show: false
            },
            selection: {
                enabled: false
            },
            zoom: {
                enabled: false
            },
            fontFamily: ChartStyles_1.defaultFontFamily
        },
        plotOptions: {
            bar: {
                horizontal: true,
                rangeBarGroupRows: true
            }
        },
        grid: {
            padding: { left: -4 },
            yaxis: {
                lines: {
                    show: false
                },
            }
        },
        xaxis: {
            min: range === null || range === void 0 ? void 0 : range.scaleMin,
            max: range === null || range === void 0 ? void 0 : range.scaleMax,
            tickAmount: 5,
            labels: {
                trim: true,
                formatter: function (value) {
                    return isNumber(value) ? (+(+value).toFixed(2)).toString() : value;
                }
            }
        },
        legend: {
            show: false
        },
        stroke: {
            width: 2,
            colors: [ChartStyles_1.RangeColor.active]
        },
        states: {
            hover: {
                filter: {
                    type: "none"
                }
            },
            active: {
                filter: {
                    type: "none"
                }
            },
        },
        fill: {
            opacity: 1
        },
        colors: [function (_a) {
                var seriesIndex = _a.seriesIndex, w = _a.w;
                return w.globals.initialSeries[seriesIndex].color;
            }],
        dataLabels: {
            enabled: true,
            formatter: function (_val, opts) {
                return opts.w.globals.initialSeries[opts.seriesIndex].name;
            },
            style: {
                colors: series.map(function (s) { return s.labelColor; }),
                fontWeight: "bold",
                fontFamily: ChartStyles_1.defaultFontFamily
            }
        },
        tooltip: {
            enabled: !lifeAgeWeightHeight,
            custom: function (_a) {
                var seriesIndex = _a.seriesIndex, w = _a.w;
                var name = w.globals.initialSeries[seriesIndex].name;
                var from = w.globals.initialSeries[seriesIndex].fixedRange[0];
                var to = w.globals.initialSeries[seriesIndex].fixedRange[1];
                return "<div class=\"apexcharts-tooltip-rangebar\"><div> <span class=\"series-name\">".concat(name, "</span></div><div> <span class=\"category\"> </span> <span class=\"value start-value\">").concat(from, "</span> <span class=\"separator\">-</span> <span class=\"value end-value\">").concat(to, "</span></div></div>");
            }
        },
        annotations: {
            xaxis: annotations
        }
    };
}
exports.getOptions = getOptions;
function getAnnotations(series, range, numericResult, lifeAge) {
    var annotationValue = lifeAge ? (numericResult && resultRange(series, numericResult) ? numericResult : range === null || range === void 0 ? void 0 : range.scaleMin) : numericResult;
    var annotations = [
        {
            x: annotationValue,
            opacity: 100,
            strokeDashArray: 0,
            borderWidth: 3,
            borderColor: ChartStyles_1.RangeColor.annotation,
            offsetY: 0,
            label: {
                borderWidth: 0,
                offsetY: -12,
                orientation: "horizontal",
                style: {
                    cssClass: "apexcharts-xaxis-annotation-label-tooltip",
                    color: rangeColor(series, annotationValue || 0)[1],
                    background: rangeColor(series, annotationValue || 0)[0],
                    fontSize: ChartStyles_1.defaultFontSize,
                    fontWeight: "bold",
                    padding: {
                        left: 8,
                        right: 8,
                        top: 4,
                        bottom: 10
                    }
                },
                text: annotationValue === null || annotationValue === void 0 ? void 0 : annotationValue.toString()
            }
        }
    ];
    return annotations;
}
exports.getAnnotations = getAnnotations;
function getDownloadTranslations(translation) {
    return downloadTranslations.map(function (key) { return ({ key: "results.".concat(key), value: translation("results.".concat(key)) }); });
}
exports.getDownloadTranslations = getDownloadTranslations;
var isNumber = function (val) { return typeof val === "number" && !isNaN(val); };
function RangeChart(props) {
    var _a = (0, react_1.useState)([]), series = _a[0], setSeries = _a[1];
    var _b = (0, react_1.useState)(undefined), options = _b[0], setOptions = _b[1];
    var _c = (0, react_1.useState)(false), annotationTooltip = _c[0], setAnnotationTooltip = _c[1];
    var _d = (0, react_1.useState)(undefined), annotationTooltipEvent = _d[0], setAnnotationTooltipEvent = _d[1];
    (0, react_1.useEffect)(function () {
        var onScroll = function (event) {
            setAnnotationTooltip(false);
        };
        window.addEventListener("scroll", onScroll);
        return function () { return window.removeEventListener("scroll", onScroll); };
    }, []);
    (0, react_1.useEffect)(function () {
        var _a;
        if (!props.range) {
            return;
        }
        var series = mapSeries(props.range, props.translation, props.lifeAgeWeightHeight);
        setSeries(series);
        var annotations = getAnnotations(series, props.range, props.numericResult, props.lifeAge);
        annotations[0].label.mouseEnter = function (_, e) {
            var rect = e.target.getBoundingClientRect();
            if (e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom) {
                setAnnotationTooltipEvent(e);
                setAnnotationTooltip(true);
            }
        };
        annotations[0].label.mouseLeave = function (_, e) {
            var rect = e.target.getBoundingClientRect();
            if (e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom - 7) {
                setAnnotationTooltipEvent(e);
                setAnnotationTooltip(true);
            }
            else {
                setAnnotationTooltip(false);
            }
        };
        if (props.secondResult !== undefined && props.secondResult !== props.numericResult) {
            annotations.push({
                x: props.secondResult,
                opacity: 100,
                strokeDashArray: 0,
                borderWidth: 3,
                borderColor: ChartStyles_1.RangeColor.annotation,
                offsetY: 0,
                label: {
                    borderWidth: 0,
                    offsetY: -12,
                    orientation: "horizontal",
                    style: {
                        color: ChartStyles_1.RangeColor.active,
                        background: ChartStyles_1.RangeColor.annotation,
                        fontSize: ChartStyles_1.defaultFontSize,
                        fontWeight: "bold",
                        padding: {
                            left: 8,
                            right: 8,
                            top: 4,
                            bottom: 10
                        }
                    },
                    text: (_a = props.secondResult) === null || _a === void 0 ? void 0 : _a.toString()
                }
            });
        }
        setOptions(getOptions(series, props.range, props.lifeAgeWeightHeight, annotations));
    }, [props.range, props.numericResult, props.lifeAge, props.lifeAgeWeightHeight, props.secondResult, props.translation]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        options && react_1.default.createElement(react_apexcharts_1.default, { series: series, options: options, height: 132, width: "100%", type: "rangeBar" }),
        annotationTooltip && react_1.default.createElement("div", { className: "apexcharts-tooltip apexcharts-theme-light custom-chart-annotation-tooltip", style: { left: annotationTooltipEvent === null || annotationTooltipEvent === void 0 ? void 0 : annotationTooltipEvent.clientX, top: annotationTooltipEvent === null || annotationTooltipEvent === void 0 ? void 0 : annotationTooltipEvent.clientY } },
            react_1.default.createElement("div", { className: "apexcharts-tooltip-rangebar" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", { className: "category" }, props.translation("results.yourResult")))))));
}
exports.RangeChart = RangeChart;
